{
  "package": "tago-tours-catalog",
  "version": "1.0.0",
  "generatedFor": "Tago Rent — agencia de viajes (los tours los ofrece Tago)",
  "operator": {
    "hostId": "tourhost_tago",
    "userEmail": "tours@tago.rent",
    "displayName": "Tago",
    "businessName": "Tago Rent"
  },
  "assets": {
    "bucket": "tours-covers",
    "baseUrl": "https://api.tago.rent/storage/v1/object/public/tours-covers",
    "coverWidth": 1600,
    "coverHeight": 1000
  },
  "units": [
    {
      "id": "tourunit_tago_microbus",
      "label": "Microbús",
      "makeModel": "Microbús 15 pasajeros",
      "licensePlate": "MI-0001",
      "seats": 15,
      "cargoVolumeM3": 1.5
    },
    {
      "id": "tourunit_tago_coaster",
      "label": "Coaster",
      "makeModel": "Toyota Coaster",
      "licensePlate": "CO-0002",
      "seats": 26,
      "cargoVolumeM3": 3.0
    },
    {
      "id": "tourunit_tago_bus",
      "label": "Bus",
      "makeModel": "Bus 45 pasajeros",
      "licensePlate": "BU-0003",
      "seats": 45,
      "cargoVolumeM3": 6.0
    },
    {
      "id": "tourunit_tago_van_ejecutiva",
      "label": "Van Ejecutiva",
      "makeModel": "Van ejecutiva 8 pasajeros",
      "licensePlate": "VA-0004",
      "seats": 8,
      "cargoVolumeM3": 2.0
    }
  ],
  "categories": [
    { "id": "viajes-ejecutivos", "name": "Viajes Ejecutivos" },
    { "id": "eventos", "name": "Eventos" }
  ],
  "routes": [
    {
      "slug": "ruta-de-las-flores",
      "experienceId": "tourexp_ruta_de_las_flores",
      "title": "Ruta de las Flores",
      "categoryId": null,
      "originLabel": "San Salvador",
      "destinationLabel": "Apaneca · Ataco · Juayúa",
      "durationMinutes": 600,
      "distanceKm": 180,
      "mainVehicle": "microbus",
      "schedule": { "weekday": 6, "hourLocal": 7 },
      "tariffs": { "microbus": 23000, "coaster": 35000, "bus": 48000 },
      "palette": ["#5B1E8C", "#F0422D"],
      "motif": "flowers",
      "stops": [
        { "kind": "pickup", "label": "San Salvador", "lat": 13.6929, "lng": -89.2182 },
        { "kind": "waypoint", "label": "Apaneca", "lat": 13.8586, "lng": -89.804 },
        { "kind": "waypoint", "label": "Concepción de Ataco", "lat": 13.8714, "lng": -89.8486 },
        { "kind": "destination", "label": "Juayúa", "lat": 13.8425, "lng": -89.7461 }
      ],
      "description": "Un recorrido por los pueblos de montaña más coloridos de El Salvador: Apaneca, Concepción de Ataco y Juayúa. Cafetales, murales, artesanías y gastronomía en un solo día, con paradas para fotos y compras. Salida y regreso desde San Salvador. Tarifas por vehículo: Microbús $200 · Coaster $320 · Bus $450."
    },
    {
      "slug": "ruta-los-volcanes",
      "experienceId": "tourexp_ruta_los_volcanes",
      "title": "Ruta Los Volcanes",
      "categoryId": null,
      "originLabel": "San Salvador",
      "destinationLabel": "Cerro Verde · Volcán de Izalco · Lago de Coatepeque",
      "durationMinutes": 600,
      "distanceKm": 120,
      "mainVehicle": "microbus",
      "schedule": { "weekday": 6, "hourLocal": 7 },
      "tariffs": { "microbus": 22000, "coaster": 33000, "bus": 45500 },
      "palette": ["#0E2A47", "#E8792B"],
      "motif": "volcano",
      "stops": [
        { "kind": "pickup", "label": "San Salvador", "lat": 13.6929, "lng": -89.2182 },
        { "kind": "waypoint", "label": "Cerro Verde", "lat": 13.8261, "lng": -89.6253 },
        { "kind": "waypoint", "label": "Volcán de Izalco", "lat": 13.8125, "lng": -89.6333 },
        { "kind": "destination", "label": "Lago de Coatepeque", "lat": 13.8667, "lng": -89.55 }
      ],
      "description": "Naturaleza viva: el bosque nuboso de Cerro Verde, el imponente Volcán de Izalco y el mirador al Lago de Coatepeque. Un día de senderos, vistas y aire fresco con guía. Salida desde San Salvador. Tarifas por vehículo: Microbús $190 · Coaster $300 · Bus $425."
    },
    {
      "slug": "ruta-panoramica",
      "experienceId": "tourexp_ruta_panoramica",
      "title": "Ruta Panorámica",
      "categoryId": null,
      "originLabel": "San Salvador",
      "destinationLabel": "Miradores de Los Chorros · Lago de Ilopango",
      "durationMinutes": 300,
      "distanceKm": 60,
      "mainVehicle": "microbus",
      "schedule": { "weekday": 6, "hourLocal": 8 },
      "tariffs": { "microbus": 15000 },
      "palette": ["#241B52", "#FF7A59"],
      "motif": "sunset",
      "stops": [
        { "kind": "pickup", "label": "San Salvador", "lat": 13.6929, "lng": -89.2182 },
        { "kind": "waypoint", "label": "Mirador de Los Chorros", "lat": 13.7333, "lng": -89.3167 },
        {
          "kind": "destination",
          "label": "Mirador del Lago de Ilopango",
          "lat": 13.6667,
          "lng": -89.05
        }
      ],
      "description": "Un paseo corto para ver El Salvador desde arriba: miradores, carretera de montaña y los mejores atardeceres cerca de la capital. Ideal para medio día. Tarifa por vehículo: Microbús $120."
    },
    {
      "slug": "playa-el-tunco",
      "experienceId": "tourexp_playa_el_tunco",
      "title": "Playa El Tunco",
      "categoryId": null,
      "originLabel": "San Salvador",
      "destinationLabel": "Playa El Tunco",
      "durationMinutes": 480,
      "distanceKm": 70,
      "mainVehicle": "microbus",
      "schedule": { "weekday": 6, "hourLocal": 15 },
      "tariffs": { "microbus": 22000 },
      "palette": ["#0B1B3A", "#1B6E8C"],
      "motif": "waves",
      "stops": [
        { "kind": "pickup", "label": "San Salvador", "lat": 13.6929, "lng": -89.2182 },
        { "kind": "waypoint", "label": "Puerto de La Libertad", "lat": 13.4886, "lng": -89.3222 },
        { "kind": "destination", "label": "Playa El Tunco", "lat": 13.4939, "lng": -89.3833 }
      ],
      "description": "La playa más famosa del país, de noche. Olas, música en vivo, restaurantes y ambiente bohemio hasta tarde. Salida por la tarde y regreso en la noche. Ambiente nocturno. Tarifa por vehículo: Microbús $190."
    },
    {
      "slug": "surf-city",
      "experienceId": "tourexp_surf_city",
      "title": "Surf City",
      "categoryId": null,
      "originLabel": "San Salvador",
      "destinationLabel": "Muelle · Artesanías · Juegos mecánicos",
      "durationMinutes": 480,
      "distanceKm": 70,
      "mainVehicle": "microbus",
      "schedule": { "weekday": 6, "hourLocal": 13 },
      "tariffs": { "microbus": 22000 },
      "palette": ["#0A3D62", "#22B8CF"],
      "motif": "coast",
      "stops": [
        { "kind": "pickup", "label": "San Salvador", "lat": 13.6929, "lng": -89.2182 },
        { "kind": "waypoint", "label": "Muelle de La Libertad", "lat": 13.4886, "lng": -89.3222 },
        {
          "kind": "destination",
          "label": "Mercado de Artesanías y juegos mecánicos",
          "lat": 13.49,
          "lng": -89.325
        }
      ],
      "description": "El corazón del surf salvadoreño: el muelle de La Libertad, el mercado de artesanías y juegos mecánicos. Una tarde-noche junto al mar para toda la familia. Tarifa por vehículo: Microbús $190."
    },
    {
      "slug": "city-tours",
      "experienceId": "tourexp_city_tours",
      "title": "City Tours",
      "categoryId": null,
      "originLabel": "San Salvador",
      "destinationLabel": "Puerta del Diablo · Planes de Renderos · Centro Histórico",
      "durationMinutes": 360,
      "distanceKm": 45,
      "mainVehicle": "microbus",
      "schedule": { "weekday": 0, "hourLocal": 8 },
      "tariffs": { "microbus": 21000, "coaster": 32000, "bus": 45500 },
      "palette": ["#3A1C5A", "#F0422D"],
      "motif": "city",
      "stops": [
        { "kind": "pickup", "label": "San Salvador", "lat": 13.6929, "lng": -89.2182 },
        { "kind": "waypoint", "label": "Puerta del Diablo", "lat": 13.6476, "lng": -89.1907 },
        { "kind": "waypoint", "label": "Planes de Renderos", "lat": 13.65, "lng": -89.1833 },
        {
          "kind": "destination",
          "label": "Centro Histórico de San Salvador",
          "lat": 13.6989,
          "lng": -89.1914
        }
      ],
      "description": "San Salvador en un día: la Puerta del Diablo, los miradores de Planes de Renderos y el Centro Histórico con su catedral y mercado. Historia, vistas y comida típica. Tarifas por vehículo: Microbús $180 · Coaster $290 · Bus $425."
    },
    {
      "slug": "suchitoto",
      "experienceId": "tourexp_suchitoto",
      "title": "Suchitoto",
      "categoryId": null,
      "originLabel": "San Salvador",
      "destinationLabel": "Suchitoto · Lago de Suchitlán",
      "durationMinutes": 540,
      "distanceKm": 100,
      "mainVehicle": "microbus",
      "schedule": { "weekday": 0, "hourLocal": 7 },
      "tariffs": { "microbus": 23000, "coaster": 34000, "bus": 45500 },
      "palette": ["#123A3A", "#C9A227"],
      "motif": "lake",
      "stops": [
        { "kind": "pickup", "label": "San Salvador", "lat": 13.6929, "lng": -89.2182 },
        { "kind": "waypoint", "label": "Suchitoto", "lat": 13.9383, "lng": -89.0278 },
        { "kind": "destination", "label": "Lago de Suchitlán", "lat": 13.95, "lng": -89.02 }
      ],
      "description": "El pueblo colonial junto al lago, con calles de piedra, iglesia centenaria y arte. Paseo en lancha por el Lago de Suchitlán y almuerzo con vista. Tarifas por vehículo: Microbús $200 · Coaster $310 · Bus $425."
    },
    {
      "slug": "playas-de-la-union",
      "experienceId": "tourexp_playas_de_la_union",
      "title": "Playas de La Unión",
      "categoryId": null,
      "originLabel": "San Salvador",
      "destinationLabel": "La Unión · Playa El Espino · Golfo de Fonseca",
      "durationMinutes": 720,
      "distanceKm": 320,
      "mainVehicle": "microbus",
      "schedule": { "weekday": 6, "hourLocal": 6 },
      "tariffs": { "microbus": 31000, "coaster": 38000, "bus": 50500 },
      "palette": ["#0B3B5A", "#E0B060"],
      "motif": "islands",
      "stops": [
        { "kind": "pickup", "label": "San Salvador", "lat": 13.6929, "lng": -89.2182 },
        { "kind": "waypoint", "label": "La Unión", "lat": 13.3369, "lng": -87.8439 },
        { "kind": "destination", "label": "Playa El Espino", "lat": 13.2167, "lng": -87.9833 }
      ],
      "description": "Las playas del oriente y el Golfo de Fonseca: arena, islas y marisco fresco. Un día completo en las aguas más tranquilas del país. Tarifas por vehículo: Microbús $280 · Coaster $350 · Bus $475."
    },
    {
      "slug": "chalatenango",
      "experienceId": "tourexp_chalatenango",
      "title": "Chalatenango",
      "categoryId": null,
      "originLabel": "San Salvador",
      "destinationLabel": "Chalatenango · La Palma",
      "durationMinutes": 600,
      "distanceKm": 150,
      "mainVehicle": "microbus",
      "schedule": { "weekday": 6, "hourLocal": 7 },
      "tariffs": { "microbus": 28000, "coaster": 34000, "bus": 48000 },
      "palette": ["#0F3D2E", "#7BC96F"],
      "motif": "forest",
      "stops": [
        { "kind": "pickup", "label": "San Salvador", "lat": 13.6929, "lng": -89.2182 },
        { "kind": "waypoint", "label": "Chalatenango", "lat": 14.0333, "lng": -88.9333 },
        { "kind": "destination", "label": "La Palma", "lat": 14.3167, "lng": -89.1667 }
      ],
      "description": "Tierra de montañas y clima fresco: La Palma, sus artesanías y murales, y los paisajes del norte. Una escapada de un día al corazón verde del país. Tarifas por vehículo: Microbús $250 · Coaster $310 · Bus $450."
    },
    {
      "slug": "traslado-ejecutivo-aeropuerto",
      "experienceId": "tourexp_traslado_ejecutivo_aeropuerto",
      "title": "Traslado Ejecutivo — Aeropuerto",
      "categoryId": "viajes-ejecutivos",
      "originLabel": "San Salvador",
      "destinationLabel": "Aeropuerto Internacional",
      "durationMinutes": 75,
      "distanceKm": 45,
      "mainVehicle": "van_ejecutiva",
      "schedule": { "weekday": 1, "hourLocal": 5 },
      "tariffs": { "van_ejecutiva": 12000 },
      "palette": ["#0B1526", "#3E5C76"],
      "motif": "road",
      "stops": [
        { "kind": "pickup", "label": "San Salvador", "lat": 13.6929, "lng": -89.2182 },
        {
          "kind": "destination",
          "label": "Aeropuerto Internacional Monseñor Óscar A. Romero",
          "lat": 13.4409,
          "lng": -89.0557
        }
      ],
      "description": "Traslado privado para ejecutivos y equipos de empresa: puntualidad, unidad con aire acondicionado y espacio para equipaje. Puerta a puerta desde San Salvador al aeropuerto, con conductor asignado. Tarifa por vehículo: Van Ejecutiva $90."
    },
    {
      "slug": "evento-noche-de-museos",
      "experienceId": "tourexp_evento_noche_de_museos",
      "title": "Evento — Noche de Museos",
      "categoryId": "eventos",
      "originLabel": "San Salvador",
      "destinationLabel": "Centro Histórico",
      "durationMinutes": 240,
      "distanceKm": 20,
      "mainVehicle": "microbus",
      "schedule": { "weekday": 5, "hourLocal": 18 },
      "tariffs": { "microbus": 18000, "coaster": 25000 },
      "palette": ["#2A1B4A", "#B23A8A"],
      "motif": "event",
      "stops": [
        { "kind": "pickup", "label": "San Salvador", "lat": 13.6929, "lng": -89.2182 },
        {
          "kind": "waypoint",
          "label": "Museo Nacional de Antropología",
          "lat": 13.6968,
          "lng": -89.2244
        },
        { "kind": "destination", "label": "Plaza Barrios", "lat": 13.6989, "lng": -89.1914 }
      ],
      "description": "Transporte para eventos culturales en el Centro Histórico: ida, recorrido entre sedes y regreso, con horario fijo y unidad completa para tu grupo. Tarifas por vehículo: Microbús $150 · Coaster $220."
    },
    {
      "slug": "ruta-maya-centroamerica",
      "experienceId": "tourexp_ruta_maya_centroamerica",
      "title": "Ruta Maya — Centroamérica",
      "categoryId": null,
      "originLabel": "San Salvador",
      "destinationLabel": "Copán, Honduras · Antigua, Guatemala",
      "originCountry": "SV",
      "destinationCountry": "GT",
      "durationMinutes": 1440,
      "distanceKm": 620,
      "mainVehicle": "coaster",
      "schedule": { "weekday": 6, "hourLocal": 5 },
      "tariffs": { "coaster": 45000, "bus": 59000 },
      "palette": ["#14343A", "#C9A227"],
      "motif": "hills",
      "stops": [
        { "kind": "pickup", "label": "San Salvador", "lat": 13.6929, "lng": -89.2182 },
        { "kind": "waypoint", "label": "Copán Ruinas, Honduras", "lat": 14.8385, "lng": -89.1406 },
        { "kind": "destination", "label": "Antigua Guatemala", "lat": 14.5586, "lng": -90.7295 }
      ],
      "description": "Paquete regional de varios días que cruza fronteras: ruinas mayas, pueblos coloniales y volcanes de Centroamérica, con transporte y paradas incluidas. Salida desde San Salvador hacia Honduras y Guatemala. Tarifas por vehículo: Coaster $420 · Bus $560."
    }
  ]
}
